export const ESTADO_REVISION_DOCUMENTO_COMERCIAL = {
  PENDIENTE: 1,
  VALIDADO: 2,
  RECHAZADO: 3,
  ELIMINADO: 4,
  BORRADOR: 5,
} as const

export type EstadoRevisionDocumentoComercialType =
  (typeof ESTADO_REVISION_DOCUMENTO_COMERCIAL)[keyof typeof ESTADO_REVISION_DOCUMENTO_COMERCIAL]
